import React from 'react';
import { Stack, Text } from '@fluentui/react';

import styles from './styles.module.scss';
import { EventType } from '../../../../props/events';
import GeneralConfig from '../../../../config';

type ErrorPageProps = {
  children?: React.ReactNode;
  event: EventType;
};

const ErrorPage: React.FC<ErrorPageProps> = (props) => {
  const { event } = props;
  return (
    <Stack
      className={styles.container}
      styles={{
        root: { backgroundImage: `url(${GeneralConfig.assetsHostname}/${event.thankyouBackground?.url})` },
      }}
      tokens={{ childrenGap: 100 }}
    >
      <Stack className={styles.textContainer} tokens={{childrenGap: 20}}>
        <Text className={`${styles.text} ${styles.title}`} style={{color: event.errorTitleColor || 'unset'}}>{event.errorTitle}</Text>
        <Text className={`${styles.text} ${styles.subTitle}`} style={{color: event.errorDescriptionColor || 'unset'}}>{event.errorDescription}</Text>
      </Stack>
    </Stack>
  );
};

export default ErrorPage;
